import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { supabase } from '../../services/Supabase';
import { toast } from 'react-toastify';

/* React Icons */
import { FaSpinner } from 'react-icons/fa';
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import CompanyLogo from "../../assets/img/company-logo.webp";
const UpdatePassword = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');
    const [loadingButton, setLoadingButton] = useState(false);
    const [showPass, setShowPass] = useState(false);
    const [showConfirmPass, setShowConfirmPass] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // Check if we have a session (user came from reset email)
        const checkSession = async () => {
            try {
                const { data: { session }, error } = await supabase.auth.getSession();
                console.log('Initial session check:', session ? 'Session exists' : 'No session');
                
                if (error){
                    var errorMsg = error.message || 'Error checking session';
                    toast.error(errorMsg);
                    throw error;
                }
                
                if (!session) {
                    toast.error('No session found, redirecting to forgot password');
                    navigate('/forgot-password');
                }
            } catch (error) {
                console.error('Session check error:', error);
                toast.error('Session check error, redirecting to forgot password');
                navigate('/forgot-password');
            }
        };
        
        checkSession();

        // Listen for auth changes
        const { data: { subscription } } = supabase.auth.onAuthStateChange(async (event, session) => {
            console.log('Auth state change event:', event);
            if(event === 'USER_UPDATED'){
                toast.success('Password updated successfully! Redirecting to dashboard...');
                setTimeout(async () => {
                    window.location.href = '/dashboard';
                }, 2000);
            }
        });

        return () => {
            subscription?.unsubscribe();
        };
    }, [navigate]);

    const handleUpdatePassword = async (e) => {
        e.preventDefault();
        
        if (password !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }

        if (password.length < 6) {
            setError('Password must be at least 6 characters');
            return;
        }

        setLoadingButton(true);
        setMessage('');
        setError('');

        try {
            console.log('1. Attempting to update password...');
            
            // Use .then() to ensure we capture the response
            const updatePromise = supabase.auth.updateUser({
                password: password
            });

            // Log that we're waiting
            console.log('2. Waiting for update response...');

            const { data, error } = await updatePromise;

            // This should now execute
            console.log('3. Update response received:', { 
                data: data ? 'Data exists' : 'No data', 
                error: error ? error.message : 'No error' 
            });
            
            // Log the full response object
            console.log('4. Full response:', JSON.stringify({ data, error }, null, 2));

            if (error) {
                console.error('5. Error in update:', error);
                throw error;
            }

            if (data) {
                console.log('6. Update successful! Data:', data);
                setMessage('Password updated successfully! Redirecting to login...');
                
                // Don't sign out immediately, wait a bit
                setTimeout(async () => {
                try {
                    console.log('7. Attempting to sign out...');
                    const { error: signOutError } = await supabase.auth.signOut();
                    
                    if (signOutError) {
                    console.error('8. Sign out error:', signOutError);
                    } else {
                    console.log('9. Signed out successfully');
                    }
                    
                    console.log('10. Navigating to login...');
                    navigate('/login');
                } catch (signOutErr) {
                    console.error('11. Sign out catch error:', signOutErr);
                    navigate('/login');
                }
                }, 3000); // Increased to 3 seconds to ensure we see the logs
            }
            
        } catch (error) {
            console.error('12. Password update error caught:', error);
            setError(error.message);
        } finally {
            console.log('13. Finally block executed');
            setLoadingButton(false);
        }
    };

    return (
        <section className="main-form-section">
            <div className="container">
                <div className="banner-wrapper">
                    <div className="form-section-wrapper">
                        <form onSubmit={handleUpdatePassword}>
                            <div className="form-header"><img src={CompanyLogo} alt="Company Logo" /></div>
                            <div className="login-heading">
                                <h2>UPDATE PASSWORD</h2>
                            </div>
                            {message && (
                                <div className="success-txt-msg">
                                    {message}
                                </div>
                            )}

                            {error && (
                                <div className="error-txt-msg">
                                    {error}
                                </div>
                            )}
                            {/* New Password */}
                            <div className="form-wrapper">
                                <label htmlFor="password">New Password</label>
                                <div className="form-group">
                                    <input type={showPass ? "text" : "password"} className="form-input" id="password" name="password" placeholder="New Password" value={password} onChange={(e) => setPassword(e.target.value)} required />
                                    <i className="show-icon">{showPass ? <AiOutlineEyeInvisible onClick={()=>setShowPass((prevState) => !prevState)} /> : <AiOutlineEye onClick={()=>setShowPass((prevState) => !prevState)} />}</i>
                                </div>
                            </div>
                            {/* Confirm Password */}
                            <div className="form-wrapper">
                                <label htmlFor="confirmPassword">Confirm Password</label>
                                <div className="form-group">
                                    <input type={showConfirmPass ? "text" : "password"} className="form-input" id="confirmPassword" name="confirmPassword" placeholder="Confirm Password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} required />
                                    <i className="show-icon">{showConfirmPass ? <AiOutlineEyeInvisible onClick={()=>setShowConfirmPass((prevState) => !prevState)} /> : <AiOutlineEye onClick={()=>setShowConfirmPass((prevState) => !prevState)} />}</i>
                                </div>
                            </div>

                            <div className="form-group">
                                {loadingButton ? 
                                    (<button className="submit-button w-100" type="button"><FaSpinner className="spinner" disabled /> Changing, Please wait... </button>) : 
                                    (<button className="submit-button w-100" id="submit-button" type="submit"> Change Password</button>)
                                }
                            </div>
                            <div className="sign-in-text">
                                <ul>
                                    <li>Already have an account? <Link to="/sign-in">Sign In</Link></li>
                                </ul>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default UpdatePassword;